import * as React from 'react';
import {useDispatch} from 'react-redux';
import DropZone from '../../../../../common/components/dropzone/DropZone';
import LoaderIcon from '../../../../../common/components/loader/LoaderIcon';
import {FILES_SECTION} from '../../../../loan/common/constants/LabelConstants';
import {MAX_FILE_SIZE} from '../../../../constants/AttachmentContants';
import {CHATS} from '../../../constants/LabelConstants';
import {Creators as ChatDataActions} from '../../../reducers/chat/data';

const ChatsUploadFilesView: React.FC<null> = (): React.ReactElement => {
    const dispatch = useDispatch();
    const [isUploading, setIsUploading] = React.useState(false);
    const [error, setError] = React.useState('');
    const onDropFile = (file, error) => {
        setError(error);
        if (error) return;
        setIsUploading(!!file);
        dispatch(ChatDataActions.uploadChatDocument(file));
    };
    return (
        <div className="container px-0">
            <div className="row">
                <div className="col">
                    {isUploading ? (
                        <div className="p-6">
                            <LoaderIcon />
                        </div>
                    ) : (
                        <div className="m-1 p-3">
                            <DropZone
                                id="dropzone"
                                label={CHATS.UPLOAD_LABEL}
                                maxSize={MAX_FILE_SIZE}
                                multiple={false}
                                labelButton={
                                    FILES_SECTION.UPLOAD_FILES_SELECT_LABEL
                                }
                                hasError={!!error}
                                labelError={error}
                                onDrop={onDropFile}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ChatsUploadFilesView;
